import React from 'react';
import { CompassIcon } from 'lucide-react';
import { images } from '../../data/content';
import { CTAButton } from '../CTAButton';
import { Countdown } from '../Countdown';
interface HeroProps {
  ctaId: string;
}
export function Hero({
  ctaId
}: HeroProps) {
  return <header className="bg-cream px-4 pb-14 pt-8 sm:pt-12" data-id="element-172" data-mp="huxrrr3a8nwo">
      <div className="mx-auto max-w-5xl text-center" data-id="element-173" data-mp="hwimbgplk6uj">
        <div className="inline-flex items-center gap-2.5" data-id="element-174" data-mp="muk663uuka72">
          <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-brand-dark text-white" data-id="element-175" data-mp="mrxzs7jp00qf">
            <CompassIcon className="h-5 w-5" aria-hidden="true" data-id="element-176" data-mp="qt9gfnkl9bmh" />
          </span>
          <span className="font-serif text-xl font-bold text-brand-dark" data-id="element-177" data-mp="vn47jc2iwsvl">Sensory Clinical Route™</span>
        </div>

        <h1 className="mx-auto mt-7 max-w-4xl font-serif text-[34px] font-extrabold leading-[1.1] text-ink sm:text-5xl md:text-6xl" data-id="element-178" data-mp="10n9tqcq0xn6a">
          Turn an organized sensory case into a clear next-step plan in{' '}
          <em className="text-brand" data-id="element-179" data-mp="9nt1i2ffirjh">15 minutes</em>
        </h1>
        <p className="mx-auto mt-5 max-w-2xl text-[17px] leading-relaxed text-muted sm:text-xl" data-id="element-180" data-mp="9pdrdeqstmb0">
          — without second-guessing what to do next. A step-by-step clinical workflow that helps Occupational Therapists move from organized observations to clear investigation, functional goals, documentation and next clinical steps.
        </p>
        <p className="mx-auto mt-4 max-w-2xl text-[17px] leading-relaxed text-ink sm:text-lg" data-id="element-181" data-mp="se0wtycw0dp4">
          Includes <strong data-id="element-182" data-mp="nepe4jsymy4w">6 Premium Volumes</strong>, <strong data-id="element-183" data-mp="ngily2fb7oeh">5 Professional Bonuses</strong> and <strong data-id="element-184" data-mp="iohequx00nvb">30+ practical decision tools</strong>.
        </p>

        <figure className="mx-auto mt-8 max-w-3xl" data-id="element-185" data-mp="imxu6s4b7qnq">
          <img src={images.mainMockup} alt="The Sensory Clinical Route™ — 6 volumes, 5 bonuses and 30+ clinical tools" className="-mx-2 w-[calc(100%+1rem)] max-w-none sm:mx-auto sm:w-full sm:max-w-full" data-id="element-186" data-mp="enfcs6bp5xpn" />
        </figure>

        <div className="mt-8" data-id="element-187" data-mp="16c8r1yijh0wl">
          <CTAButton id={ctaId} label="Get the Sensory Clinical Route™" showSubtext data-id="element-188" data-mp="30ldxmyt0nwlb" />
          <Countdown data-id="element-189" data-mp="35kqumcdlqk1m" />
        </div>
      </div>
    </header>;
}